define('views/modules/calendar/calendar/filter/filter',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'moment',
    // events
    // Collections
    'collections/calendar/personal-data/personal-data-types',
    // views
    'views/parts/menu/menu',
    // Templates
    'text!templates/parts/filter/filter.html',
    'text!templates/parts/filter/filter-item.html',
], function(
    // libs
    _, Backbone, Mustache, U, moment,
    // events
    // Collections and models
    CPersonalDataTypes,
    // views
    VMenu,
    // templates
    TFilter,
    TFilterItem
) {

    var VFilter = Backbone.View.extend({
        template: TFilter,
        events: {

        },

        regions: {
            menu: ".filter",
        },

        initialize: function(opt) {
            this.options = opt || {};
            this.parent = this.options.parent;

            this.collection = new Backbone.Collection([
                { title: 'calendar:Marked as "done"', filter: "completed", active: true },
                { title: 'calendar:Marked as "incomplete"', filter: "incomplete", active: true },
                { title: 'Activities', filter: "activity", active: true },
                { title: 'calendar:Animated Sessions', filter: "animated", active: true },
                { title: 'calendar:Nutrition', filter: "nutrition", active: true },
            ]);

            this.customFilters = new CPersonalDataTypes();

            this.view = {
                menu: new VMenu({
                    collection: this.collection,
                    onClick: this.onFilterClick,
                    templateItem: TFilterItem,
                    context: this,
                    toggle: true,
                })
            };

            this.listenTo(this.customFilters, "sync", this.onCustomFiltersLoaded);
        },

        render: function() {

            // Render HTML template
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            // caching element into this.zone
            this.generateZones();
            this.assign(this.view.menu, this.zone.$menu);

            this.customFilters.fetch();

            return this;
        },

        _renderFilters: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));
            this.generateZones();

            this.assign(this.view.menu, this.zone.$menu);

            return this;
        },

        ///////////////
        /// events ///
        /////////////

        onFilterClick: function(e, item) {
            e.preventDefault();
            this.trigger("filter:click", item);
        },

        onCustomFiltersLoaded: function(customFilters) {
            var idAttribute = CPersonalDataTypes.prototype.model.prototype.idAttribute;
            customFilters.each(function(filter) {
                this.collection.add([{
                    title: filter.get('name'),
                    filter: 'custom_data',
                    active: true,
                    id: filter.get(idAttribute),
                }]);
            }, this);
            this._renderFilters();
        },

    });

    return VFilter;

});

